var RetailerSearch = function RetailerSearch(context, list, mapObject)
{
	var self = this;
	self.context = $(context);
	self.list = $(list);
	self.map = mapObject;

	self.countryName 		= "sverige";	
	self.countryCenter 		= new google.maps.LatLng(63.113077, 16.6372206);
	self.directionsService 	= new google.maps.DirectionsService();
    self.directionsDisplay 	= new google.maps.DirectionsRenderer();

    self.init = function() {

        // Add all markers from backend list
        if (window.markers != null) {
            self.addMarkers();
        }

        self.context.on('submit',
            function(e) {
                e.preventDefault();

                var address = self.context.find("input").val() + ', ' + self.countryName;

                self.findLocation({ 'address': address });
            });

        // Auto target current physical position
        self.findByCurrentPosition();

        self.list.on('click', '.partial-reseller-page .card-title a',
            function(e) {
                e.preventDefault();
                //var id = $(this).parents('.reseller:first').attr('id');
                var id = $(this).data('id');
                var list = window.markers.filter(function(item) {
                    return (item.id == id);
                });

                if (list.length) {
                    var marker = list[0].gMarker;
                    self.map.setCenter(marker.position);
                    self.map.setZoom(14);

                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            });
    };	

	self.findByCurrentPosition = function() {

		if (navigator.geolocation) {

			navigator.geolocation.getCurrentPosition(function (position) {
				var pos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				self.findLocation({ 'latLng': pos });
			});
		}
	}

	self.ShowMarkerNCalcDistance = function(findNear) {

		for (index = 0; index < window.markers.length; index++) {
            var marker = window.markers[index];
		    
			//Visar alla markers
			marker.gMarker.setVisible(true);

			//Mäter på hur långt återförsäljaren är från den inmatade adressen.
			if (marker.latlng != null) {
				var distance = google.maps.geometry.spherical.computeDistanceBetween(findNear, marker.latlng);
				marker.distance = distance;
			}
			else {
				marker.distance = null;
			}
		}
	}

	self.findLocation = function(locationSearchObject) {
		var geocoder = new google.maps.Geocoder();
		console.info("Google looking for", locationSearchObject)

	    geocoder.geocode(locationSearchObject, function (results, status) {

	        if (status == google.maps.GeocoderStatus.OK) {

	            var searchLocation = results[0].geometry.location;

	            self.ShowMarkerNCalcDistance(searchLocation);

	            // Sort to distance
	            markers.sort(sortByDistance);

	            // Copy the nearest 3, this is a global variable all opther methods works with, so lets keep it intact, and workaround the index problems later
	            var sortedMarkers = markers.slice(0, 2);

	            var circ = new google.maps.Circle();
	            circ.setRadius(sortedMarkers[sortedMarkers.length - 1].distance);
	            circ.setCenter(searchLocation);
	            self.map.setCenter(searchLocation);
	            self.map.fitBounds(circ.getBounds());

	            var markersWithShowRoom = [];
	            var markersWithoutShowRoom = [];

	            for (i = 0; i < sortedMarkers.length; i++) {
	                marker = sortedMarkers[i];
	                if (marker.Showroom) {
	                    markersWithShowRoom.push(marker);
	                } else {
	                    markersWithoutShowRoom.push(marker);
	                }
	            }

	            sortedMarkers = $.merge(markersWithShowRoom, markersWithoutShowRoom);

	            self.sortList();
	        }
	        else {
	        	console.warn("Google GeocoderStatus", status)
	            alert("Kunde inte hitta den angivna platsen");
	        }
	    });
	}

    self.sortList = function() {

        var items = [];

        self.list.find('.card.partial-reseller-page').each(function(key, item) {

            var marker = self.getMarkerById($(item).attr('id'));
            if (marker == null || marker.length === 0) {
                console.log('No marker found with id "' + $(item).attr('id') + '"!');
            }

            $(item).parent().data('marker', marker);
            items.push($(item).parent().detach());
        });

        items.sort(sortListByDistance);

        self.list.find('.sub-page-listing .row').append(items);
    };

    self.getMarkerById = function(id) {
        for (var index in window.markers) {
            var marker = window.markers[index];
            if (marker.id == id) {
                return marker;
            }
        }

        return null;
    };

    self.addMarkers = function() {

        var showRoomMarkerImage = new google.maps.MarkerImage('/ui/default/img/pin-black.png', null, null, null);
        var noAfMarkerImage = new google.maps.MarkerImage('/ui/default/img/pin-grey.png', null, null, null);
        console.log(window.markers)
        for (var index = 0; index < window.markers.length; index++) {
            // Fetch marker from list
            var marker = window.markers[index];

            // Convert positon to google maps latlng
            marker.latlng = new google.maps.LatLng(marker.latitude, marker.longitude);

            // Setup marker data with positon and map
            var markerData = {
                position: marker.latlng,
                map: self.map,
                title: marker.title
            };

            // Determine if marker is showroom
            if (marker.hasOwnProperty('showroom') && marker.showroom) {
                markerData.icon = showRoomMarkerImage;
            } else {
                markerData.icon = noAfMarkerImage;
            }

            // Create google maps marker object with data
            var gMarker = new google.maps.Marker(markerData);

            // Save marker
            marker.gMarker = gMarker;

            // Two way binding
            gMarker.markerData = marker;
            
            bindMarker(self.list.find('#' + marker.id), gMarker);
        }
    };

	function bindMarker(item, marker){
		google.maps.event.addListener(marker, 'click', function (e) {

            console.log(item[0].getBoundingClientRect());

		    window.scroll({
                top: item[0].getBoundingClientRect().top - 50,
		        left: 0,
		        behavior: 'smooth'
		    });

			item.addClass('flash');

		    setTimeout(function() {
		            item.removeClass('flash');
		        }, 2500);
		});
	}


	self.init();

	function sortListByDistance(a, b) {
		var markerA = a.data('marker');
        var markerB = b.data('marker');
        
		if (markerA.distance == null) {
	        return 1;
	    }
        if (markerB.distance == null) {
	        return -1;
	    }

	    if (markerA.distance > markerB.distance) {
	        return 1;
	    }
	    else if (markerA.distance == markerB.distance) {
	        return 0;
	    }
	    else {
	        return -1;
	    }
	}

	function sortByDistance(a, b) {
	    if (a.distance == null) {
	        return 1;
        }

	    if (b.distance == null) {
	        return -1;
	    }

	    if (a.distance > b.distance) {
	        return 1;
	    }
	    else if (a.distance == b.distance) {
	        return 0;
	    }
	    else {
	        return -1;
	    }
	}
}